
<template>

<div class="mess-maitnenance">
Configurateur en maintenance !
</div>

</template>

<script>

export default {
 
}
</script>

<style scoped>
.color-load{
  color:rgba(1, 69, 140, 1.000) !important;
}

/* Absolute Center Spinner */
.mess-maitnenance {
  position: fixed;
  z-index: 999;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 228px;
  height: 50px;
}

</style>